<template>

  <div id="detailCanvas" ref="detailCanvas" class="detailContent canvas-box">
    <div class="title">
      <div class="title-name">{{ $t('data.payin_details') }}
        <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="pay-status tag-custom"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag></div>
      <!-- <img height="25" src="@/assets/logo/ezpay_logo.svg"> -->
    </div>
    <div class="detail-download-container">
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num "> {{ $store.getters.currency }}  {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>
      <div class="section-title mb-12 mt-12">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue"> {{ $t('data.payin_created') }}</span>
        <span class="content-gray"> {{ merchantInfo.transaction_create_time }} </span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payin_completed') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_complete_time') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp&&merchantInfo.trans_void_resp.void_complete_time }}</span>
      </div>

      <div class="section-title mb-12 mt-36">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ merchantInfo.transaction_status === TRANSACTION_STATUS['void']?$t('customerService.original_transaction_id'):$t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>

      <div v-if="merchantInfo.channel_reference_no" class="item">
        <span class="item-left content-blue">{{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_reference_no }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp&&merchantInfo.trans_void_resp.void_no }}</span>
      </div>

      <div class="download-time mt-48">{{ $t('data.download_time') }}: {{ Date.now() | parseTime() }}</div>
    </div>

  </div>

</template>

<script>
import html2canvas from 'html2canvas'
import { payTransactionStatusVoidMap } from '@/utils/maps'
export default {
  name: 'PayinDetailDownload',
  props: {
    merchantInfo: {
      type: Object,
      default: function() {
        return {
          merchant: {
            merchant_basic_info: {}
          },
          disbursement_fee: {
          }
        }
      }
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      void: 4
    }
    return {
    }
  },
  computed: {
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    }
  },
  methods: {
    saveImg() {
      const val = 'detailCanvas'
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      const node = document.getElementById(val)

      const width = node.offsetWidth
      const height = node.offsetHeight
      const scale = 2
      html2canvas(node, {
        width: width,
        heigth: height,
        backgroundColor: '#ffffff',
        dpi: window.devicePixelRatio * 2,
        scale: scale,
        X: 0,
        Y: 0,
        scrollX: -3,
        scrollY: 0,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const url = canvas.toDataURL()
        const a = document.createElement('a')
        a.download = 'Payin_' + (new Date()).getTime()
        const event = new MouseEvent('click')
        a.href = url
        a.dispatchEvent(event)
      })
    },
    onClickCancel() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style scoped lang="scss">
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 31px 10px 25px;
  border-bottom: 1px solid rgba(54, 66, 80, 0.20);
  .title-name{
    display: flex;
    align-items: center;
    color: #488CE8;
    font-size: 16px;
    font-weight: 600;

  }
  .pay-status{
    margin-left: 12px;
    line-height: 25px;
    display: inline-block;
  }
}
.detail-download-container{
  padding :24px;
}

.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #488CE8;
  }
}

.item{
  display: flex;
  margin-top: 16px;
  font-size: 12px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}
.canvas-box{
  position: absolute;
  top: -300vh;
  background: #FFFFFF;
  // display: none;
}

.download-time{
  padding: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #488CE8;
  line-height: 1.5;
}

</style>
